module.exports = __webpack_public_path__ + "static/media/bestofmorty.a37330a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Awards/bestofmorty.png
// module id = 619
// module chunks = 0 1 2 3 4 34